"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "80.01",
    height: "38.79",
    viewBox: "0 0 80.01 38.79"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.5,26.67v2.4H8.06v-2.4h3.83V14.43L9.17,16.69a1.09,1.09,0,0,1-.48.24H8l-.25-.21-1-1.39,5.74-4.87h2.65V26.67Z",
    transform: "translate(0.01 0.01)",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M46.15,26.67v2.4H35.72v-2.4h3.82V14.43l-2.71,2.26a1.09,1.09,0,0,1-.45.24h-.77l-.24-.21-1-1.39,5.64-5h2.64V26.67Z",
    transform: "translate(0.01 0.01)",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M72.56,9.94v2.4H62.12V9.94H66V1c0-.41,3.2.42,3.2.42V10Z",
    transform: "translate(0.01 0.01)",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M74.12,34.32a12.19,12.19,0,0,1-.38,3.76l-12.87.07a12.7,12.7,0,0,1-.42-3.83,15.44,15.44,0,0,1,.42-4.17,8.59,8.59,0,0,1,1.46-3,5.78,5.78,0,0,1,2-1.88,6.61,6.61,0,0,1,5.46,0A5.88,5.88,0,0,1,72,27.05a8.86,8.86,0,0,1,1.46,3A15.53,15.53,0,0,1,74.12,34.32Zm-3.79-3.48a7.08,7.08,0,0,0-.8-2.12,2.87,2.87,0,0,0-5,0,7.08,7.08,0,0,0-.8,2.12,19.85,19.85,0,0,0,0,6.79c.21.9,6.37.9,6.58,0a15.23,15.23,0,0,0,.31-3.31A30,30,0,0,0,70.33,30.84Z",
    transform: "translate(0.01 0.01)",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.77,38.78H0V0H25.77ZM2.7,36.06H23.05V2.7H2.7Z",
    transform: "translate(0.01 0.01)",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M52.87,38.78H27.12V0H52.87Zm-23-2.72H50.19V2.7H29.84Z",
    transform: "translate(0.01 0.01)",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M80,38.78H54.22V0H80ZM56.94,36.06H77.29V2.7H56.94Z",
    transform: "translate(0.01 0.01)",
    fill: "#004864"
  }));
};

exports["default"] = _default;